import { ExportJobsTableFiltersActionTypes, ExportJobsTableFiltersState, SET_EXPORT_JOBS_TABLE_FILTERS } from './types';

const defaultState: ExportJobsTableFiltersState = {
  isLoading: false,
  errorMessage: '',
  contents: { dates: 'LastWeek' },
  exists: false,
};

export default function exportJobsTableFilters(state = defaultState, action: ExportJobsTableFiltersActionTypes): ExportJobsTableFiltersState {
  switch (action.type) {
    case SET_EXPORT_JOBS_TABLE_FILTERS:
      return { ...state, contents: action.contents, isLoading: false, exists: action.exists };
    default:
      return state;
  }
}
